import type { ParagraphTwoColsTableText as ParagraphTwoColsTableTextData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 12 — `PARAGRAPH_TWO_COLS_TABLE_TEXT_LAYOUT`: 2 kolumny (tabela HTML | tekst).
 *
 * Tabela renderowana z `text` (admin wstawia `<table>` w edytorze WYSIWYG).
 * HtmlText ma już style dla `<table>` (border, padding, header background).
 */
export function ParagraphTwoColsTableText({
  paragraph,
  t,
}: {
  paragraph: ParagraphTwoColsTableTextData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      <div className={styles.colsTwo}>
        <HtmlText html={paragraph.text} />
        <HtmlText html={paragraph.text_1} />
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
